var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('portal-target',{attrs:{"name":"modals"}}),_c('router-view',{attrs:{"name":"header"}}),_c('router-view',{staticClass:"relative"}),_c('bottom')],1)}
var staticRenderFns = []

export { render, staticRenderFns }